import styled from 'styled-components';

export const ZeroMargin = styled.div`
	p {
		color: ${(props: { textColor?: string }) => props.textColor};
		margin: 0;
	}
`;
